import * as React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import 'antd/dist/antd.css';

import JungPage from './pages/JungPage/JungPage';
import HollandPage from './pages/HollandPage/HollandPage';
import LoginPage from './pages/LoginPage/LoginPage';
import RegisterPage from './pages/RegisterPage/RegisterPage';
import ProfilePage from './pages/ProfilePage/ProfilePage';
import JungProfilePage from './pages/JungProfilePage/JungProfilePage';
import HollandProfilePage from './pages/HollandProfilePage/HollandProfilePage';

import LoggedIn from './components/LoggedIn/LoggedIn';

const LoggedInRoute = ({ component: Component, ...otherProps }): any => (
  <Route
    {...otherProps}
    render={(props) => (
      <LoggedIn {...props}>
        <Component {...props} />
      </LoggedIn>
    )}
  />
);


class Routes extends React.Component<{}>{
  public render(){
    return (
      <Router>
        <Switch>
          <Route exact path={'/login'} component={LoginPage} />
          <Route exact path={'/cadastro'} component={RegisterPage} />
          <LoggedInRoute exact path={'/'} component={ProfilePage} />
          <LoggedInRoute exact path={'/jung'} component={JungPage} />
          <LoggedInRoute exact path={'/resultado-jung/:profile'} component={JungProfilePage} />
          <LoggedInRoute exact path={'/resultado-holland/:id'} component={HollandProfilePage} />
          <LoggedInRoute exact path={'/holland'} component={HollandPage} />
        </Switch>
      </Router>
    )
  }
}

export default Routes
